import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "../../Sidebar";
import {
  Divider,
  Paper,
  Typography,
   Grid,
   Button,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment"
import base from '../../base.json'


const drawerWidth = 80;
export class PendingVendorDesc extends Component {
    constructor(props) {
      super(props)
      this.state = {
           ////// Personal Information (Vendors)

      vendor_personal_first_name: "",
      vendor_personal_last_name: "",
      vendor_personal_sirname: "",

      //////// Contact Details
      vender_personal_address: "",
      vender_personal_email: "",
      vender_personal_city: "",
      vender_personal_state: "",
      vender_personal_pincode: "",
      vendor_personal_whatsapp_no: "",
      vendor_personal_contact_number: "",

      ////////////  ID information
      vender_personal_abc_id: "",
      vendor_personal_pan_no: "",
      vendor_personal_adharcard_number: "",

      //////////  Financial Details
      vender_personal_bank_account_no: "",
      vendor_personal_bank_ifsc_code: "",
      vendor_personal_bank_name: "",
      vender_personal_bank_account_type: "",
      vendor_personal_bank_branch_name: "",
      vendor_personal_bank_account_holder_name: "",

      /////////// Attachment Details

      vendor_pan_card_docs: "",
      vendor_adhar_card_docs: "",
      vendor_bank_account_docs: "",
      vendor_address_docs: "",


      vendor_photo: [],
      vendor_video: [],
      vendors_thumb_nails_img : "",

      /////////////// Bussiness information //////////

      business_name: "",
      business_contact_no: "",
      bussiness_email_id: "",
      bussiness_exprence: "",

      bussiness_category: "",
      bussiness_sub_category: "",

      //////////////////////////////////
      vendor_id : "",
      is_vendor_verified : false,
    

      };
    };


componentDidMount(){
    this.retriveVenderDetails();
}




    retriveVenderDetails=()=>{
      let id= this.props.param.id.replace(/:/g, "");
     
         this.setState({is_loader_open : true},()=>{
            fetch(
               `${base.base_url}/admin/getSingleVendorDetails/:${id}`,
               {
                 headers: {
                   "content-type": "application/json",
                 },
                 method: "get",
               }
             )
               .then((res) => {
                 return res.json();
               })
               .then((result) => {
                 this.setState({
              
         vendor_id : result.data.vendor_id,


          vendor_personal_first_name: result.data.vendor_personal_first_name,
          vendor_personal_last_name: result.data.vendor_personal_last_name,
          vendor_personal_sirname: result.data.vendor_personal_sirname,
    
          //////// Contact Details
          vender_personal_address: result.data.vender_personal_address,
          vender_personal_email: result.data.vender_personal_email,
          vender_personal_city: result.data.vender_personal_city,
          vender_personal_state: result.data.vender_personal_state,
          vender_personal_pincode: result.data.vender_personal_pincode,
          vendor_personal_whatsapp_no: result.data.vendor_personal_whatsapp_no,
          vendor_personal_contact_number: result.data.vendor_personal_contact_number,
    
          ////////////  ID information
          vender_personal_abc_id: result.data.vender_personal_abc_id,
          vendor_personal_pan_no: result.data.vendor_personal_pan_no,
          vendor_personal_adharcard_number: result.data.vendor_personal_adharcard_number,
    
          //////////  Financial Details
          vender_personal_bank_account_no: result.data.vender_personal_bank_account_no,
          vendor_personal_bank_ifsc_code: result.data.vendor_personal_bank_ifsc_code,
          vendor_personal_bank_name: result.data.vendor_personal_bank_name,
          vender_personal_bank_account_type: result.data.vender_personal_bank_account_type,
          vendor_personal_bank_branch_name: result.data.vendor_personal_bank_branch_name,
          vendor_personal_bank_account_holder_name: result.data.vendor_personal_bank_account_holder_name,
    
          /////////// Attachment Details
    
          vendor_pan_card_docs: result.data.vendor_pan_card_docs,
          vendor_adhar_card_docs: result.data.vendor_adhar_card_docs,
          vendor_bank_account_docs: result.data.vendor_bank_account_docs,
          vendor_address_docs: result.data.vendor_address_docs,
    
    
          vendor_photo: result.data.vendor_photo,
          vendor_video: result.data.vendor_video,
          vendors_thumb_nails_img : result.data.vendors_thumb_nails_img,
    
          /////////////// Bussiness information //////////
    
          business_name: result.data.business_name,
          business_contact_no: result.data.business_contact_no,
          bussiness_email_id: result.data.bussiness_email_id,
          bussiness_exprence: result.data.bussiness_exprence,
    
          bussiness_category: result.data.bussiness_category,
           bussiness_sub_category : result.data.bussiness_sub_category,
          is_loader_open  :false,
          is_vendor_verified : result.data.is_vendor_verified,
                 })
    
                })
              })
    
    }
    

    verifyVendorStatus=()=>{
      /// verifyVendorStatus
         let id= this.props.param.id.replace(/:/g, "");
         this.setState({is_loader_open : true},()=>{
            fetch(
               `${base.base_url}/admin/verifyVendorStatus`,
               {
                 headers: {
                   "content-type": "application/json",
                 },
                 method: "put",
                 body:JSON.stringify({
                   vender_id : id,
                 })
               }
             )
               .then((res) => {
                 return res.json();
               })
               .then((result) => {
                 this.setState({
                  is_loader_open : false,
                 },()=>{
                  this.retriveVenderDetails();
                 })
                })
              })
    }





    
  render() {
    return (
      <div>

 <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 1 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
                Vender Details Description
              </Typography>
           <Box>
        





<Paper variant="outlined" sx={{minHeight:70}}>
<Box sx={{p:2}}>
<Grid container spacing={2} >   

<Grid size={{xs:6,sm:3,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>VENDOR ID</Typography>
<Typography sx={{fontSize:12,color:'black',mt:2}}>{this.state.vendor_id}</Typography>
</Grid>

<Grid size={{xs:6,sm:3,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>VENDOR FIRST NAME</Typography>
<Typography sx={{fontSize:12,color:'black',mt:2}}>{this.state.vendor_personal_first_name}</Typography>
</Grid>

<Grid size={{xs:6,sm:3,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>VENDOR LAST NAME</Typography>
<Typography sx={{fontSize:12,color:'black',mt:2}}>{this.state.vendor_personal_last_name}</Typography>
</Grid>

<Grid size={{xs:6,sm:3,md:4}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>STATUS</Typography>
{
this.state.is_vendor_verified?<Box sx={{height:30,width:100,backgroundColor:'#2da802',display:'flex',justifyContent:'center',alignItems:'center',mt:2}}><Typography sx={{fontSize:14,fontWeight:'bold',color:'#fff'}}>Verified</Typography> </Box>:<Button size="small" variant="contained" sx={{fontSize:12,textTransform:'none',mt:2}} onClick={this.verifyVendorStatus}>Give Approval For Listing</Button>  
}
</Grid>



</Grid>
</Box>
</Paper>


<Paper variant="outlined" sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600', textTransform:'uppercase'}}>Bussiness Details</Typography>
<Box sx={{height:2,width:220,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>

<Box sx={{pl:2,pr:2,pb:2}}>
<Grid container spacing={2} >

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}> CITY</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_city}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>STATE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_state}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>PIN CODE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_pincode}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>CONTACT</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_contact_number}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>WHATS APP NO</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_whatsapp_no}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>EMAIL </Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_email}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ADDRESS</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_address}</Typography>
</Grid>


</Grid>
</Box>

<Divider/>

<Box sx={{pl:2,pr:2,pb:2,pt:2}}>
<Grid container spacing={2} >

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>BUSINESS NAME</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.business_name}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>BUSINESS CONTACT NO</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.business_contact_no}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>BUSINESS EMAIL ID</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.bussiness_email_id}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>EXPRIENCE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.bussiness_exprence}</Typography>
</Grid>


</Grid>
</Box>


</Paper>


<Paper variant="outlined" sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600', textTransform:'uppercase'}}>ID information</Typography>
<Box sx={{height:2,width:140,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>

<Box sx={{pl:2,pr:2,pb:2}}>
<Grid container spacing={2} >

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ABC ID</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_abc_id}</Typography>
</Grid>


<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ADHAAR CARD</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_adharcard_number}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>PAN CARD</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_pan_no}</Typography>
</Grid>


</Grid>
</Box>




</Paper>


<Paper variant="outlined" sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600', textTransform:'uppercase'}}>Financial Details</Typography>
<Box sx={{height:2,width:140,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>

<Box sx={{pl:2,pr:2,pb:2}}>
<Grid container spacing={2} >

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Bank Account No</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_bank_account_no}</Typography>
</Grid>


<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>IFSC Code</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_bank_ifsc_code}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Bank Name</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_bank_name}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Account Type</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vender_personal_bank_account_type}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Branch Name</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_bank_branch_name}</Typography>
</Grid>

<Grid size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Account Holder Name</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.vendor_personal_bank_account_holder_name}</Typography>
</Grid>


</Grid>
</Box>

</Paper>





<Paper variant="outlined" sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600', textTransform:'uppercase'}}>Attachment Details</Typography>
<Box sx={{height:2,width:140,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>

<Box sx={{pl:2,pr:2,pb:2}}>
<Grid container spacing={2} >

<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Pan card photo</Typography>
<Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{this.state.vendor_pan_card_docs}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+this.state.vendor_pan_card_docs)}>View</Button>
</Box>
</Grid>


<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}} >Adhar card Photo</Typography>
<Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{this.state.vendor_adhar_card_docs}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+this.state.vendor_adhar_card_docs)}>View</Button>
</Box>
</Grid>

<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Bank Account Photo</Typography>
<Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{this.state.vendor_bank_account_docs}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+this.state.vendor_bank_account_docs)}>View</Button>
</Box>
</Grid>

<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Address Proff</Typography>
<Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{this.state.vendor_address_docs}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+this.state.vendor_address_docs)}>View</Button>
</Box>
</Grid>


<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Bussiness Photo</Typography>
<Box sx={{display:'flex',flexDirection:'column'}}>

{ this.state.vendor_photo.map((i)=>{
    <Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{i.name}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+ i.name)}>View</Button>
</Box>   
})
 
}
</Box>
</Grid>


<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Bussiness Video</Typography>
<Box sx={{display:'flex',flexDirection:'column'}}>

{ this.state.vendor_video.map((i)=>{
    <Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{i.name}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+ i.name)}>View</Button>
</Box>   
})
 
}
</Box>

</Grid>


<Grid size={{xs:6,sm:4,md:3}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>Thumb nail image</Typography>
<Box sx={{height:30,width:'100%',backgroundColor:'#f8f8f8',display:'flex',flexDirection:'row',mt:2}}>
 <Typography sx={{fontSize:11}}>{this.state.vendors_thumb_nails_img}</Typography>
 <Button variant="contained" sx={{fontSize:10,height:20,width:80,textTransform:'none'}} onClick={()=>window.open(base.base_url+'/'+this.state.vendors_thumb_nails_img)}>View</Button>
</Box>
</Grid>





</Grid>
</Box>
<br/>


</Paper>











</Box>

            </Box>
          </Box>
        </Box>

      </div>
    )
  }
}

export default PendingVendorDesc

export function PendingVendorDescc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<PendingVendorDesc param={param} navigate={navigate}></PendingVendorDesc>)
}
